import { render, staticRenderFns } from "./report-list.vue?vue&type=template&id=1364ab36&scoped=true&"
import script from "./report-list.vue?vue&type=script&lang=ts&"
export * from "./report-list.vue?vue&type=script&lang=ts&"
import style0 from "./report-list.vue?vue&type=style&index=0&id=1364ab36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1364ab36",
  null
  
)

export default component.exports